import { render, staticRenderFns } from "./pop-over.vue?vue&type=template&id=3ba40b65&"
import script from "./pop-over.vue?vue&type=script&lang=js&"
export * from "./pop-over.vue?vue&type=script&lang=js&"
import style0 from "./pop-over.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports